import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

/**
 * Thrown when a long-running handler exceeds its timeout. Used by the
 * appointment task processor to break out of a hung handler so the queue
 * can flow through the retry/backoff path; raised on the timeout side of
 * the Promise.race so it can be distinguished from the handler's own
 * eventual rejection.
 */
export class HandlerTimeoutError extends EluveError {
  static override readonly errorName = 'HandlerTimeoutError';
  readonly logLevel: LogLevel = 'warn';

  constructor(message = 'Handler timed out', args?: EluveErrorArgs) {
    super(message, args);
  }
}
